import React, { useRef, useCallback, useState } from "react";
import { Formik, Form } from "formik";
import { Box, Button, Grid, Typography } from "@mui/material";
import "react-phone-input-2/lib/style.css";
import "./family.css";
import ImageUploadBoxMultiple from "../../../../../common/imageUploadBox/image-upload-box-multiple";


const Family = ({ updateFormData, nextStep, prevStep }) => {
  const webcamRefs = useRef([]); // Array of webcam references
  const fileInputRefs = useRef([]); // Array of file input references
  const [openIndexes, setOpenIndexes] = useState([]); // Array to manage which webcam is open
  const [imageSrcs, setImageSrcs] = useState([]); // Array to store multiple images

  // Function to capture the image from the webcam for a specific index
  const capture = useCallback((index) => {
    if (webcamRefs.current[index]) {
      const image = webcamRefs.current[index].getScreenshot();
      setImageSrcs((prev) => {
        const updatedImages = [...prev];
        updatedImages[index] = image; // Store the captured image for this index
        return updatedImages;
      });
    } else {
      console.error("Webcam not ready.");
    }
  }, []);

  const handleButtonClick = (index) => {
    fileInputRefs.current[index].click();
  };

  const handleFileChange = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrcs((prev) => {
          const updatedImages = [...prev];
          updatedImages[index] = reader.result; // Store the uploaded image for this index
          return updatedImages;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  // Initial values for Formik
  const initialValues = {
    familyInfo: {
      images: [], // Initialize images array to store multiple images
    },
  };

  return (
    <Box className='family-container-form'>
      {/* Top character */}
      <Box className='top-character'>
        <img src='./CYPImages/Ellipse.png' alt='top character' className='top-character-image' />
      </Box>
      <Box className='left-character'>
        <img src='./CYPImages/WormisConversations.png' alt='left character' className='left-character-image' />
      </Box>
      <Formik
        initialValues={initialValues} // Make sure initialValues is set
        onSubmit={(values) => {
          // Ensure the familyInfo object exists and then spread its values
          updateFormData({ familyInfo: { ...values.familyInfo, images: imageSrcs } });
          nextStep(); // Move to next form
        }}
        validateOnMount={false}
        validateOnBlur={true}
      >
        {({ handleSubmit }) => (
          <Box mt={8}>
            <Form onSubmit={handleSubmit} className='family-guide-form'>
              {/* Form Header */}
              <Typography
                variant='h4'
                className='form-title'
                sx={{ fontSize: "34px", fontFamily: "Love Ya Like A Sister", color: " #1364FF" }}
              >
                My Family
              </Typography>
              <Typography className='form-instructions' sx={{ textAlign: "center", mt: 1, fontSize: "12px" }}>
                If it’s ok with your Social Worker and they think it’s safe, you may be able to stay in touch with
                members of your family and friends.
                <br />
                <br />
                You could ask your key workers to help you write their contact details down. You could also draw a
                picture of their face or something that reminds you of them.
              </Typography>

              {/* Draw/Upload Section */}
              <Grid container spacing={3} mt={4}>
                {Array.from({ length: 4 }).map((_, index) => (
                  <ImageUploadBoxMultiple
                    key={index}
                    index={index}
                    imageSrc={imageSrcs[index]}
                    openIndexes={openIndexes}
                    webcamRef={webcamRefs}
                    fileInputRef={fileInputRefs}
                    handleButtonClick={handleButtonClick}
                    handleFileChange={handleFileChange}
                    capture={capture}
                    setOpenIndexes={setOpenIndexes}
                  />
                ))}
              </Grid>

              {/* Next Button */}
              <Grid container justifyContent='space-between' alignItems='center' mt={2}>
                <Grid item>
                  <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                    Previous
                  </Button>
                </Grid>
                <Grid item>
                  <Button type='submit' variant='contained' color='primary'>
                    Next
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </Box>
        )}
      </Formik>

      {/* Bottom character */}
      <Box className='bottom-character'>
        <img src='./CYPImages/Wormis.png' alt='Bottom Character' className='bottom-character-image' />
      </Box>
    </Box>
  );
};

export default Family;
